import React from 'react';
import MaterialIcon from '../MaterialIcon';

const Products = ({ setIsModalOpen }) => {
  return (
    <section id="products-section" className="relative py-16 md:py-24 bg-white">
      <div className="absolute inset-0">
        <div className="absolute top-40 right-0 w-96 h-96 bg-[#F1F600]/10 rounded-full mix-blend-multiply filter blur-2xl"></div>
        <div className="absolute bottom-40 left-20 w-96 h-96 bg-[#2C3E50]/5 rounded-full mix-blend-multiply filter blur-2xl"></div>
      </div>

      <div className="relative container-wide">
        <div className="text-center mb-24">
          <h2 className="text-5xl font-bold mb-6">
            <span className="relative inline-block group">
              <span className="bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 bg-clip-text text-transparent">核心产品</span>
              <div className="absolute -bottom-2 left-0 w-full h-1 bg-gradient-to-r from-amber-400 to-yellow-400 transform scale-x-50 group-hover:scale-x-100 transition-transform duration-500"></div>
            </span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto font-medium">专业教练服务，助力企业和个人实现突破性成长</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 md:gap-12 max-w-[85%] mx-auto">
          {/* 创始人教练 */}
          <div className="group relative">
            <div className="absolute -inset-0.5 bg-gradient-to-r from-amber-500 to-yellow-500 rounded-[22px] blur opacity-10 group-hover:opacity-20 transition-opacity duration-500"></div>
            <div className="relative h-full bg-white rounded-[20px] p-8 shadow-sm hover:shadow-lg transition-all duration-300">
              <div className="relative w-20 h-20 mb-8">
                <div className="absolute inset-0 bg-gradient-to-br from-amber-200 to-yellow-100 rounded-2xl rotate-6 group-hover:rotate-12 transition-transform duration-300 ease-out"></div>
                <div className="absolute inset-0 bg-white rounded-2xl">
                  <div className="w-full h-full bg-gradient-to-br from-amber-400 to-yellow-400 rounded-2xl flex items-center justify-center transform group-hover:scale-105 transition-transform duration-300 ease-out">
                    <MaterialIcon icon="rocket_launch" className="text-white text-3xl" />
                  </div>
                </div>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4 group-hover:text-amber-600 transition-colors duration-300">创始人教练</h3>
              <p className="text-gray-600 mb-6 leading-relaxed">
                专注服务创始人从0到1、1到10的关键阶段，通过深度教练对话，助力商业决策、战略规划和组织建设。
              </p>
              <ul className="space-y-3 text-gray-600">
                <li className="flex items-center space-x-3 transform translate-x-0 group-hover:translate-x-1 transition-transform duration-200 ease-out">
                  <MaterialIcon icon="check_circle" className="text-amber-500 text-sm" />
                  <span>商业模式验证与优化</span>
                </li>
                <li className="flex items-center space-x-3 transform translate-x-0 group-hover:translate-x-1 transition-transform duration-200 ease-out">
                  <MaterialIcon icon="check_circle" className="text-amber-500 text-sm" />
                  <span>战略决策与风险管理</span>
                </li>
                <li className="flex items-center space-x-3 transform translate-x-0 group-hover:translate-x-1 transition-transform duration-200 ease-out">
                  <MaterialIcon icon="check_circle" className="text-amber-500 text-sm" />
                  <span>组织架构与人才梯队</span>
                </li>
                <li className="flex items-center space-x-3 transform translate-x-0 group-hover:translate-x-1 transition-transform duration-200 ease-out">
                  <MaterialIcon icon="check_circle" className="text-amber-500 text-sm" />
                  <span>创始人个人成长突破</span>
                </li>
              </ul>
              <div className="mt-8">
                <button 
                  onClick={() => setIsModalOpen(true)}
                  className="inline-flex items-center text-amber-600 font-semibold hover:text-amber-700 transition-colors duration-300"
                >
                  了解更多
                  <MaterialIcon icon="arrow_forward" className="ml-2 text-sm transform group-hover:translate-x-1 transition-transform duration-300" />
                </button>
              </div>
            </div>
          </div>

          {/* 高管全景领导力工作坊 */}
          <div className="group relative">
            <div className="absolute -inset-0.5 bg-gradient-to-r from-purple-500 to-violet-500 rounded-[22px] blur opacity-10 group-hover:opacity-20 transition-opacity duration-500"></div>
            <div className="relative h-full bg-white rounded-[20px] p-8 shadow-sm hover:shadow-lg transition-all duration-300">
              <div className="relative w-20 h-20 mb-8">
                <div className="absolute inset-0 bg-gradient-to-br from-purple-200 to-violet-100 rounded-2xl rotate-6 group-hover:rotate-12 transition-transform duration-300 ease-out"></div>
                <div className="absolute inset-0 bg-white rounded-2xl">
                  <div className="w-full h-full bg-gradient-to-br from-purple-400 to-violet-400 rounded-2xl flex items-center justify-center transform group-hover:scale-105 transition-transform duration-300 ease-out">
                    <MaterialIcon icon="groups" className="text-white text-3xl" />
                  </div>
                </div>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4 group-hover:text-purple-600 transition-colors duration-300">高管全景领导力工作坊</h3>
              <p className="text-gray-600 mb-6 leading-relaxed">
                系统化的领导力发展项目，通过工作坊形式帮助管理者全方位提升领导能力。
              </p>
              <ul className="space-y-3 text-gray-600">
                <li className="flex items-center space-x-3 transform translate-x-0 group-hover:translate-x-1 transition-transform duration-200 ease-out">
                  <MaterialIcon icon="check_circle" className="text-purple-500 text-sm" />
                  <span>领导力模型解析</span>
                </li>
                <li className="flex items-center space-x-3 transform translate-x-0 group-hover:translate-x-1 transition-transform duration-200 ease-out">
                  <MaterialIcon icon="check_circle" className="text-purple-500 text-sm" />
                  <span>实战案例演练</span>
                </li>
                <li className="flex items-center space-x-3 transform translate-x-0 group-hover:translate-x-1 transition-transform duration-200 ease-out">
                  <MaterialIcon icon="check_circle" className="text-purple-500 text-sm" />
                  <span>团队管理技能</span>
                </li>
                <li className="flex items-center space-x-3 transform translate-x-0 group-hover:translate-x-1 transition-transform duration-200 ease-out">
                  <MaterialIcon icon="check_circle" className="text-purple-500 text-sm" />
                  <span>沟通影响力提升</span>
                </li>
              </ul>
              <div className="mt-8">
                <button 
                  onClick={() => setIsModalOpen(true)}
                  className="inline-flex items-center text-purple-600 font-semibold hover:text-purple-700 transition-colors duration-300"
                >
                  了解更多
                  <MaterialIcon icon="arrow_forward" className="ml-2 text-sm transform group-hover:translate-x-1 transition-transform duration-300" />
                </button>
              </div>
            </div>
          </div>

          {/* 教练式领导力训练营 */}
          <div className="group relative">
            <div className="absolute -inset-0.5 bg-gradient-to-r from-emerald-500 to-green-500 rounded-[22px] blur opacity-10 group-hover:opacity-20 transition-opacity duration-500"></div>
            <div className="relative h-full bg-white rounded-[20px] p-8 shadow-sm hover:shadow-lg transition-all duration-300">
              <div className="relative w-20 h-20 mb-8">
                <div className="absolute inset-0 bg-gradient-to-br from-emerald-200 to-green-100 rounded-2xl rotate-6 group-hover:rotate-12 transition-transform duration-300 ease-out"></div>
                <div className="absolute inset-0 bg-white rounded-2xl">
                  <div className="w-full h-full bg-gradient-to-br from-emerald-400 to-green-400 rounded-2xl flex items-center justify-center transform group-hover:scale-105 transition-transform duration-300 ease-out">
                    <MaterialIcon icon="school" className="text-white text-3xl" />
                  </div>
                </div>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4 group-hover:text-emerald-600 transition-colors duration-300">教练式领导力训练营</h3>
              <p className="text-gray-600 mb-6 leading-relaxed">
                帮助管理者掌握教练式领导技能，提升团队激励和员工发展能力。
              </p>
              <ul className="space-y-3 text-gray-600">
                <li className="flex items-center space-x-3 transform translate-x-0 group-hover:translate-x-1 transition-transform duration-200 ease-out">
                  <MaterialIcon icon="check_circle" className="text-emerald-500 text-sm" />
                  <span>教练式对话技巧</span>
                </li>
                <li className="flex items-center space-x-3 transform translate-x-0 group-hover:translate-x-1 transition-transform duration-200 ease-out">
                  <MaterialIcon icon="check_circle" className="text-emerald-500 text-sm" />
                  <span>团队赋能方法</span>
                </li>
                <li className="flex items-center space-x-3 transform translate-x-0 group-hover:translate-x-1 transition-transform duration-200 ease-out">
                  <MaterialIcon icon="check_circle" className="text-emerald-500 text-sm" />
                  <span>绩效改进工具</span>
                </li>
                <li className="flex items-center space-x-3 transform translate-x-0 group-hover:translate-x-1 transition-transform duration-200 ease-out">
                  <MaterialIcon icon="check_circle" className="text-emerald-500 text-sm" />
                  <span>员工发展计划</span>
                </li>
              </ul>
              <div className="mt-8">
                <button 
                  onClick={() => setIsModalOpen(true)}
                  className="inline-flex items-center text-emerald-600 font-semibold hover:text-emerald-700 transition-colors duration-300"
                >
                  了解更多
                  <MaterialIcon icon="arrow_forward" className="ml-2 text-sm transform group-hover:translate-x-1 transition-transform duration-300" />
                </button>
              </div>
            </div>
          </div>

          {/* 高管领导力突破 */}
          <div className="group relative">
            <div className="absolute -inset-0.5 bg-gradient-to-r from-orange-500 to-amber-500 rounded-[22px] blur opacity-10 group-hover:opacity-20 transition-opacity duration-500"></div>
            <div className="relative h-full bg-white rounded-[20px] p-8 shadow-sm hover:shadow-lg transition-all duration-300">
              <div className="relative w-20 h-20 mb-8">
                <div className="absolute inset-0 bg-gradient-to-br from-orange-200 to-amber-100 rounded-2xl rotate-6 group-hover:rotate-12 transition-transform duration-300 ease-out"></div>
                <div className="absolute inset-0 bg-white rounded-2xl">
                  <div className="w-full h-full bg-gradient-to-br from-orange-400 to-amber-400 rounded-2xl flex items-center justify-center transform group-hover:scale-105 transition-transform duration-300 ease-out">
                    <MaterialIcon icon="star" className="text-white text-3xl" />
                  </div>
                </div>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4 group-hover:text-orange-600 transition-colors duration-300">高管领导力突破</h3>
              <p className="text-gray-600 mb-6 leading-relaxed">
                针对企业高管的个性化教练服务，聚焦领导力提升和组织管理效能。
              </p>
              <ul className="space-y-3 text-gray-600">
                <li className="flex items-center space-x-3 transform translate-x-0 group-hover:translate-x-1 transition-transform duration-200 ease-out">
                  <MaterialIcon icon="check_circle" className="text-orange-500 text-sm" />
                  <span>高管个人发展</span>
                </li>
                <li className="flex items-center space-x-3 transform translate-x-0 group-hover:translate-x-1 transition-transform duration-200 ease-out">
                  <MaterialIcon icon="check_circle" className="text-orange-500 text-sm" />
                  <span>组织变革管理</span>
                </li>
                <li className="flex items-center space-x-3 transform translate-x-0 group-hover:translate-x-1 transition-transform duration-200 ease-out">
                  <MaterialIcon icon="check_circle" className="text-orange-500 text-sm" />
                  <span>战略思维提升</span>
                </li>
                <li className="flex items-center space-x-3 transform translate-x-0 group-hover:translate-x-1 transition-transform duration-200 ease-out">
                  <MaterialIcon icon="check_circle" className="text-orange-500 text-sm" />
                  <span>跨文化领导力</span>
                </li>
              </ul>
              <div className="mt-8">
                <button 
                  onClick={() => setIsModalOpen(true)}
                  className="inline-flex items-center text-orange-600 font-semibold hover:text-orange-700 transition-colors duration-300"
                >
                  了解更多
                  <MaterialIcon icon="arrow_forward" className="ml-2 text-sm transform group-hover:translate-x-1 transition-transform duration-300" />
                </button>
              </div>
            </div>
          </div>

          {/* 团队进化引擎 */}
          <div className="group relative">
            <div className="absolute -inset-0.5 bg-gradient-to-r from-cyan-500 to-teal-500 rounded-[22px] blur opacity-10 group-hover:opacity-20 transition-opacity duration-500"></div>
            <div className="relative h-full bg-white rounded-[20px] p-8 shadow-sm hover:shadow-lg transition-all duration-300">
              <div className="relative w-20 h-20 mb-8">
                <div className="absolute inset-0 bg-gradient-to-br from-cyan-200 to-teal-100 rounded-2xl rotate-6 group-hover:rotate-12 transition-transform duration-300 ease-out"></div>
                <div className="absolute inset-0 bg-white rounded-2xl">
                  <div className="w-full h-full bg-gradient-to-br from-cyan-400 to-teal-400 rounded-2xl flex items-center justify-center transform group-hover:scale-105 transition-transform duration-300 ease-out">
                    <MaterialIcon icon="diversity_3" className="text-white text-3xl" />
                  </div>
                </div>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4 group-hover:text-cyan-600 transition-colors duration-300">团队进化引擎</h3>
              <p className="text-gray-600 mb-6 leading-relaxed">
                通过系统化的团队教练方法，提升团队协作效能和组织绩效。
              </p>
              <ul className="space-y-3 text-gray-600">
                <li className="flex items-center space-x-3 transform translate-x-0 group-hover:translate-x-1 transition-transform duration-200 ease-out">
                  <MaterialIcon icon="check_circle" className="text-cyan-500 text-sm" />
                  <span>团队动力提升</span>
                </li>
                <li className="flex items-center space-x-3 transform translate-x-0 group-hover:translate-x-1 transition-transform duration-200 ease-out">
                  <MaterialIcon icon="check_circle" className="text-cyan-500 text-sm" />
                  <span>跨部门协作</span>
                </li>
                <li className="flex items-center space-x-3 transform translate-x-0 group-hover:translate-x-1 transition-transform duration-200 ease-out">
                  <MaterialIcon icon="check_circle" className="text-cyan-500 text-sm" />
                  <span>组织文化建设</span>
                </li>
                <li className="flex items-center space-x-3 transform translate-x-0 group-hover:translate-x-1 transition-transform duration-200 ease-out">
                  <MaterialIcon icon="check_circle" className="text-cyan-500 text-sm" />
                  <span>集体智慧激发</span>
                </li>
              </ul>
              <div className="mt-8">
                <button 
                  onClick={() => setIsModalOpen(true)}
                  className="inline-flex items-center text-cyan-600 font-semibold hover:text-cyan-700 transition-colors duration-300"
                >
                  了解更多
                  <MaterialIcon icon="arrow_forward" className="ml-2 text-sm transform group-hover:translate-x-1 transition-transform duration-300" />
                </button>
              </div>
            </div>
          </div>

          {/* AI教练 */}
          <div className="group relative">
            <div className="absolute -inset-0.5 bg-gradient-to-r from-pink-500 to-rose-500 rounded-[22px] blur opacity-10 group-hover:opacity-20 transition-opacity duration-500"></div>
            <div className="relative h-full bg-white rounded-[20px] p-8 shadow-sm hover:shadow-lg transition-all duration-300">
              <div className="relative w-20 h-20 mb-8">
                <div className="absolute inset-0 bg-gradient-to-br from-pink-200 to-rose-100 rounded-2xl rotate-6 group-hover:rotate-12 transition-transform duration-300 ease-out"></div>
                <div className="absolute inset-0 bg-white rounded-2xl">
                  <div className="w-full h-full bg-gradient-to-br from-pink-400 to-rose-400 rounded-2xl flex items-center justify-center transform group-hover:scale-105 transition-transform duration-300 ease-out">
                    <MaterialIcon icon="psychology" className="text-white text-3xl" />
                  </div>
                </div>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4 group-hover:text-pink-600 transition-colors duration-300">AI教练</h3>
              <p className="text-gray-600 mb-6 leading-relaxed">
                智能AI教练7x24小时在线，为个人与团队提供即时辅导与练习。
              </p>
              <ul className="space-y-3 text-gray-600">
                <li className="flex items-center space-x-3 transform translate-x-0 group-hover:translate-x-1 transition-transform duration-200 ease-out">
                  <MaterialIcon icon="check_circle" className="text-pink-500 text-sm" />
                  <span>个性化成长建议</span>
                </li>
                <li className="flex items-center space-x-3 transform translate-x-0 group-hover:translate-x-1 transition-transform duration-200 ease-out">
                  <MaterialIcon icon="check_circle" className="text-pink-500 text-sm" />
                  <span>情景对话与反馈</span>
                </li>
                <li className="flex items-center space-x-3 transform translate-x-0 group-hover:translate-x-1 transition-transform duration-200 ease-out">
                  <MaterialIcon icon="check_circle" className="text-pink-500 text-sm" />
                  <span>随时随地自我训练</span>
                </li>
              </ul>
              <div className="mt-8">
                <button 
                  onClick={() => setIsModalOpen(true)}
                  className="inline-flex items-center text-pink-600 font-semibold hover:text-pink-700 transition-colors duration-300"
                >
                  了解更多
                  <MaterialIcon icon="arrow_forward" className="ml-2 text-sm transform group-hover:translate-x-1 transition-transform duration-300" />
                </button>
              </div>
            </div>
          </div>

          {/* 潜在明星觉醒 */}
          <div className="group relative">
            <div className="absolute -inset-0.5 bg-gradient-to-r from-pink-500 to-rose-500 rounded-[22px] blur opacity-10 group-hover:opacity-20 transition-opacity duration-500"></div>
            <div className="relative h-full bg-white rounded-[20px] p-8 shadow-sm hover:shadow-lg transition-all duration-300">
              <div className="relative w-20 h-20 mb-8">
                <div className="absolute inset-0 bg-gradient-to-br from-pink-200 to-rose-100 rounded-2xl rotate-6 group-hover:rotate-12 transition-transform duration-300 ease-out"></div>
                <div className="absolute inset-0 bg-white rounded-2xl">
                  <div className="w-full h-full bg-gradient-to-br from-pink-400 to-rose-400 rounded-2xl flex items-center justify-center transform group-hover:scale-105 transition-transform duration-300 ease-out">
                    <MaterialIcon icon="auto_awesome" className="text-white text-3xl" />
                  </div>
                </div>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4 group-hover:text-pink-600 transition-colors duration-300">潜在明星觉醒</h3>
              <p className="text-gray-600 mb-6 leading-relaxed">
                专为中基层核心人才打造的成长加速项目，激发个人潜能，突破职业发展瓶颈，打造组织新星。
              </p>
              <ul className="space-y-3 text-gray-600">
                <li className="flex items-center space-x-3 transform translate-x-0 group-hover:translate-x-1 transition-transform duration-200 ease-out">
                  <MaterialIcon icon="check_circle" className="text-pink-500 text-sm" />
                  <span>绩效突破与提升</span>
                </li>
                <li className="flex items-center space-x-3 transform translate-x-0 group-hover:translate-x-1 transition-transform duration-200 ease-out">
                  <MaterialIcon icon="check_circle" className="text-pink-500 text-sm" />
                  <span>潜力挖掘与激活</span>
                </li>
                <li className="flex items-center space-x-3 transform translate-x-0 group-hover:translate-x-1 transition-transform duration-200 ease-out">
                  <MaterialIcon icon="check_circle" className="text-pink-500 text-sm" />
                  <span>企业文化内化</span>
                </li>
                <li className="flex items-center space-x-3 transform translate-x-0 group-hover:translate-x-1 transition-transform duration-200 ease-out">
                  <MaterialIcon icon="check_circle" className="text-pink-500 text-sm" />
                  <span>使命愿景对齐</span>
                </li>
              </ul>
              <div className="mt-8">
                <button 
                  onClick={() => setIsModalOpen(true)}
                  className="inline-flex items-center text-pink-600 font-semibold hover:text-pink-700 transition-colors duration-300"
                >
                  了解更多
                  <MaterialIcon icon="arrow_forward" className="ml-2 text-sm transform group-hover:translate-x-1 transition-transform duration-300" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Products; 
